module.exports = __webpack_public_path__ + "img/icon-gp-128x128-06-pin.8383e6b8.svg";